import moment from 'moment';

const daysPerPay = 14;
const twoWeeksAgoInDays = 13;
const startYear = 2019;
const payPerYear = 26;
export const addDays = (date, days) => {
  const result = new Date(date);
  return result.setDate(result.getDate() + days);
};

export const getPayEndDate = (year, payNumber) => {
  const firstPayDate = new Date(process.env.REACT_APP_FIRST_PAY_DATE);

  const yearDifference = Math.abs(startYear - year);
  if (year < startYear) {
    const dayDifference = yearDifference * payPerYear * daysPerPay - (payNumber - 1) * daysPerPay;
    return moment(firstPayDate)
      .subtract(dayDifference, 'days')
      .format('YYYY-MM-DD');
  }
  const dayDifference = yearDifference * payPerYear * daysPerPay + (payNumber - 1) * daysPerPay;
  return moment(firstPayDate)
    .add(dayDifference, 'days')
    .format('YYYY-MM-DD');
};

export const getPayStartDate = endDate =>
  moment(endDate)
    .subtract(twoWeeksAgoInDays, 'days')
    .format('YYYY-MM-DD');
